import {
  Component,
  OnInit,
  ViewChildren,
  ChangeDetectionStrategy,
  output,
  viewChild,
  input,
  inject,
} from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2, Angulartics2OnModule } from 'angulartics2';

import { ChartDto, DashboardDto, DashboardFavoritesDto } from '@shared/dto';
import {
  DropdownComponent,
  DropdownButtonDirective,
  DropdownItemDirective,
} from '../dropdown/dropdown.component';

@Component({
  selector: 'app-favorite-list',
  templateUrl: './favorite-list.component.html',
  styleUrls: ['./favorite-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DropdownComponent,
    DropdownButtonDirective,
    DropdownItemDirective,
    Angulartics2OnModule,
  ],
})
export class FavoriteListComponent {
  private angulartics2 = inject(Angulartics2);

  readonly chart = input<ChartDto>();

  get codename(): string {
    const chart = this.chart();
    if (chart) {
      return chart.codename;
    } else {
      return '';
    }
  }

  get favorite(): boolean {
    for (const dashboardId in this.favorites()) {
      const f = this.favorites()[dashboardId];
      for (const chart of f) {
        if (chart.codename === this.codename) {
          return true;
        }
      }
    }

    return false;
  }

  readonly dropdown = viewChild<any>('dropdown');

  editing = false;

  readonly favorites = input.required<DashboardFavoritesDto>();

  readonly dashboards = input<DashboardDto[]>([]);

  readonly addChartToDefaultDashboard = output<void>();

  readonly addChartToDashboard = output<DashboardDto>();

  readonly removeChartFromDashboard = output<DashboardDto>();

  readonly createDashboard = output<string>();

  get disabled() {
    return !(this.favorites() && this.dashboards() && this.chart()) || null;
  }

  favoriteButtonText(dashboard: DashboardDto) {
    if (dashboard && dashboard.id) {
      return this.isOnDashboard(dashboard.id) ? 'Remove From' : 'Add To';
    }
    return '';
  }

  isOnDashboard(id: number) {
    const dashboard = this.favorites()[id];
    if (dashboard) {
      return dashboard.findIndex((chart) => chart.codename === this.codename) > -1;
    }

    return false;
  }

  onFavoriteClick(dashboard: DashboardDto) {
    if (!dashboard) {
      this.addChartToDefaultDashboard.emit();
    } else if (dashboard.id && this.isOnDashboard(dashboard.id)) {
      this.removeChartFromDashboard.emit(dashboard);
    } else {
      this.addChartToDashboard.emit(dashboard);
    }
  }

  onCreateDashboard(e: any, name: string) {
    e.stopPropagation();
    e.preventDefault();

    if (name && name.trim()) {
      this.createDashboard.emit(name);
      this.dropdown().close();

      this.angulartics2.eventTrack.next({
        action: 'Create',
        properties: {
          category: 'Dashboard',
          label: this.codename,
        },
      });
    }
  }

  onOpenChange(open: boolean) {
    if (!open) {
      this.editing = false;
    }
  }

  showCreateDashboardForm() {
    this.editing = true;
  }
}
